import { ButtonsSectionComponent } from './buttons-section.component';

export const routes = [{ path: '', component: ButtonsSectionComponent }];
